import { render, staticRenderFns } from "./evaluationPaper.vue?vue&type=template&id=7c3684b9&scoped=true"
import script from "./evaluationPaper.vue?vue&type=script&lang=js"
export * from "./evaluationPaper.vue?vue&type=script&lang=js"
import style0 from "./evaluationPaper.vue?vue&type=style&index=0&id=7c3684b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3684b9",
  null
  
)

export default component.exports